<template>
  <bj-modal
    v-model="createInquiryScheduleModal.visible"
    size="auto"
    title="Schedule Tour"
  >
    <div slot="content">
      <div
        v-if="createInquiryScheduleModal.loading"
        class="text-center"
      >
        <q-spinner-puff
          color="primary"
          size="60px"
        />
      </div>
      <div
        v-else
        class="row gutter-sm"
      >
        <div
          v-if="shouldShowLiveVideoTourCheckbox()"
          class="col-12"
        >
          <q-field>
            <q-checkbox
              v-model="payload.is_video"
              label="Live Video Tour"
            />
          </q-field>
        </div>
        <div class="col-12">
          <autocomplete
            method="autocompleteAgent"
            :filters="{
              is_tours_capable: true,
              property_id: get(createInquiryScheduleModal, 'payload.inquiry.property_id'),
            }"
            placeholder="Agent..."
            @change="matchAnAgentSelected"
            @clear="matchAnAgentSelected"
          />
        </div>
        <div class="col-12">
          <bj-unit-schedule-tour
            v-if="schedulerUnit"
            :unit="schedulerUnit"
            :is-video="payload.is_video"
            :assignee-id="payload.agent_id"
            :chosen-assignee-label="chosenAssigneeLabel"
            @time-selected="onScheduleTourTimeSelected"
          />
        </div>
        <div class="col-auto">
          <q-btn
            outline
            :disable="disabled || !payload.tour_at"
            label="Schedule Tour"
            @click.prevent="createInquirySchedule"
          />
        </div>
      </div>
    </div>
  </bj-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import get from 'lodash.get';
import Autocomplete from '@/components/autocomplete.vue';
import BjUnitScheduleTour from '../scheduling/bj-unit-schedule-tour.vue';

export default {
  name: 'BjCreateInquiryScheduleModal',
  components: {
    Autocomplete,
    BjUnitScheduleTour,
  },
  props: {
    createInquiryScheduleModal: {
      type: Object,
      required: true,
    },
  },
  data() {
    const basePayload = {
      tour_at: null,
      agent_id: null,
      is_video: false,
    };
    return {
      base_payload: basePayload,
      payload: this.clone(basePayload),
      agentPayload: {
        inquiry: null,
        query: '',
        agent: null,
      },
      disabled: false,
    };
  },
  validations: {
    payload: {
      tour_at: { required },
    },
  },
  computed: {
    schedulerUnit() {
      const inquiry = get(this.createInquiryScheduleModal, 'payload.inquiry');
      if (!inquiry || !inquiry.unit_id) {
        return null;
      }
      const propertyTimezone = get(inquiry, 'property.timezone');
      return {
        ...get(inquiry, 'unit', {}),
        id: inquiry.unit_id,
        timezone: get(inquiry, 'unit.timezone') || propertyTimezone,
        property: {
          ...(get(inquiry, 'unit.property', {})),
          timezone: get(inquiry, 'unit.property.timezone') || propertyTimezone,
        },
      };
    },
    chosenAssigneeLabel() {
      const agent = this.agentPayload.agent;
      return get(agent, 'full_name') || get(agent, 'name') || 'the selected host';
    },
  },
  methods: {
    get,
    shouldShowLiveVideoTourCheckbox() {
      return (
        get(this.createInquiryScheduleModal, 'payload.inquiry.property.business.video_tours_enabled_at')
        && !this.isOpenHouse()
        && !this.isSelfShowing()
      );
    },
    isOpenHouse() {
      return get(this.createInquiryScheduleModal, 'payload.inquiry.unit.active_showing_profile.is_open_house');
    },
    isSelfShowing() {
      return get(this.createInquiryScheduleModal, 'payload.inquiry.unit.active_showing_profile.is_self_showing');
    },
    matchAnAgentSelected(event) {
      const { item } = event || {};
      this.agentPayload.agent = get(item, 'data', null);
      this.payload.agent_id = get(item, 'data.id', null);
    },
    onScheduleTourTimeSelected(event) {
      this.payload.tour_at = get(event, 'time', null);
      if (event && Object.prototype.hasOwnProperty.call(event, 'is_video')) {
        this.payload.is_video = !!event.is_video;
      }
    },
    createInquirySchedule() {
      const inquiryId = get(this.createInquiryScheduleModal, 'payload.inquiry.id', null);
      if (!inquiryId) {
        this.uiNotify('Unable to schedule without a valid inquiry', 'negative');
        return;
      }

      this.$v.payload.tour_at.$touch();
      if (this.$v.payload.tour_at.$invalid) {
        this.uiNotify('Please select a valid future time slot', 'negative');
        return;
      }

      this.disabled = true;
      const schedulePayload = {
        tour_at: this.payload.tour_at,
        agent_id: this.payload.agent_id,
        is_video: this.payload.is_video,
        allowed_to_proceed: true,
      };
      this.api().request('POST', `inquiries/${inquiryId}/schedule`, schedulePayload)
        .then((response) => {
          if (response.inquiry) {
            this.createInquiryScheduleModal.payload.inquiry = response.inquiry;
          }
          if (response.success === false) {
            const restrictionMessages = []
              .concat(response.strict_restrictions || [])
              .concat(response.overrode_restrictions || []);
            this.uiNotify(restrictionMessages[0] || 'Unable to schedule the selected slot', 'negative');
            return;
          }
          if (response.success) {
            this.uiNotify('Tour was created');
            this.$root.$emit('schedule-added', { ...response.inquiry, ...{ is_video: this.payload.is_video } });
          }
        }).catch((error) => {
          this.uiNotify(this.getFirstError(error) || error.message || 'Error occurred', 'negative', 5000);
        })
        .finally(() => {
          this.disabled = false;
        });
    },
  },
};

</script>

<style scoped>

</style>
